import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import { Card } from 'tea-component';
import Filter from '@/pages/intelligence/components/Filter';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import { getInitialFormValue } from './utils';
import {
  // 级联国家筛选器
  REGION as REGION_SELECT_FILTER,
  // CheckboxGroup多选Mobile数据源 筛选器
  ICONABLE_CHECKBOX_SELECT as ICONABLE_CHECKBOX_SELECT_FILTER,
  // 是否显示热度国家筛选器
  HEAT_MAP as HEAT_MAP_SELECT_FILTER,
  // 是否显示前n个国家筛选器
  SHOW_TOP_COUNTRIES as SHOW_TOP_COUNTRIES_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { DEFAULT_FORM_VALUE, STATIC_FILTER_CONFIGS } from './config';

import type { IBaseProps, IRegion } from '@/pages/intelligence/types/common';

interface IActiveRevDownFilterProps extends IBaseProps {
  // 筛选器右侧的info提示
  iconText?: React.ReactNode;
  isOperate: boolean;
  onConfirm?: (payload: any) => void;
  onReset?: () => void;
  onFilterInit?: (params: { loading: boolean, regionOptions: IRegion[] | null }) => void;
}

const ActiveRevDownFilter: React.FC<IActiveRevDownFilterProps> = (props) => {
  const { style, className, iconText, isOperate, filterValue,
    onConfirm, onReset,
    onFilterInit,
  } = props;

  /**
   * 继承逻辑在这写
   * formValue改成用ref，可提供给父组件回填时间， 或添加继承逻辑提供formValue给父组件
   */
  const { /*filterExtend,*/ setFilterExtend, resetFilterExtend } = useFilterExtend({});

  // 国家筛选器选项数据
  const { filterLoading, regionOptions } = useMarketFilterApi({}) as { filterLoading: boolean, regionOptions: IRegion[] | null };

  useEffect(() => {
    if (onFilterInit instanceof Function) {
      onFilterInit({
        loading: filterLoading,
        regionOptions,
      });
    }
  }, [filterLoading, regionOptions]);

  // 筛选器的初始值
  const initialFormValue = getInitialFormValue(isOperate, filterValue, DEFAULT_FORM_VALUE);
  // 筛选器UI渲染需要的value
  // const formValue = useRef<any>(initialFormValue);
  const [formValue, setFormValue] = useState(initialFormValue);

  useEffect(() => {
    setFormValue(initialFormValue);
  }, [
    JSON.stringify(initialFormValue),
  ]);
  // 筛选器控件配置
  const [inputList, setInputList] = useState([
    STATIC_FILTER_CONFIGS.REGION_SELECT_FILTER,
    STATIC_FILTER_CONFIGS.ICONABLE_CHECKBOX_SELECT_FILTER,
    STATIC_FILTER_CONFIGS.HEAT_MAP_SELECT_FILTER,
    STATIC_FILTER_CONFIGS.SHOW_TOP_COUNTRIES_SELECT_FILTER,
  ]);

  // 更新国家筛选器控件配置
  const updateRegionSelectFilterCfg = (inputList: any[], cfg: { options: IRegion[] | undefined | null }) => {
    const { options } = cfg || {};
    const regionFilterCfg = inputList?.find((item) => item?.key === REGION_SELECT_FILTER);
    if (regionFilterCfg && Reflect.has(regionFilterCfg, 'options')) {
      regionFilterCfg.options = Array.isArray(options) ? options : [];
    }
  };

  /**
   * 更新各个筛选器的options数据
   */
  useEffect(() => {
    const inputListTmp = [...inputList];
    // 更新国家筛选器控件配置
    updateRegionSelectFilterCfg(inputListTmp, { options: regionOptions });
    setInputList(inputListTmp);
  }, [regionOptions]);

  /**
   * 筛选器confirm的回调
   * @param value 筛选器数据（筛选器中各个组件UI渲染需要的value）
   * @param apiValue 处理后的筛选器数据，为了更方便调用接口，针对高频特殊筛选器的数据做了数据格式转换（将筛选器原始的数据转换为更方便接口入参的数据格式，同时也会保留筛选器最原始的数据，用于筛选器继承）
   */
  const handleConfirm = (value: any, apiValue: any) => {
    setFormValue(value);
    const region = apiValue?.[REGION_SELECT_FILTER];
    const dataSource = apiValue?.[ICONABLE_CHECKBOX_SELECT_FILTER];
    const showHeatMap = apiValue?.[HEAT_MAP_SELECT_FILTER];
    const showCountries = apiValue?.[SHOW_TOP_COUNTRIES_SELECT_FILTER];

    const filterTmp = {
      dataSource: dataSource?.value || [],
      regionType: region?.region_type || 'region',
      regionValue: region?.region_values || ['global'],
      showHeatMap: showHeatMap?.value,
      showCountries: showCountries?.value,
    };
    onConfirm?.(filterTmp);
    setFilterExtend(apiValue);
  };

  const handleReset = () => {
    setFormValue({
      ...DEFAULT_FORM_VALUE,
    });
    resetFilterExtend();
    onReset?.();
  };

  return (
    <Card style={style} className={classnames('dbi-common-filter', className)}>
      <Card.Body>
        <Filter
          iconText={iconText}
          inputList={inputList}
          defaultValue={DEFAULT_FORM_VALUE}
          value={formValue}
          onConfirm={handleConfirm}
          onReset={handleReset}
        />
      </Card.Body>
    </Card>
  );
};

export default ActiveRevDownFilter;
